import type { Command } from '../../types';
import type { ShapeManager } from '../ShapeManager';
import type { IShape } from '../shapes/interfaces/IShape';

export class RemoveShapes implements Command {
    private readonly shapeManager: ShapeManager;
    private readonly shapes: IShape[];

    constructor(shapeManager: ShapeManager, shapes: IShape[]) {
        this.shapeManager = shapeManager;
        this.shapes = shapes;
    }

    execute(): void {
        this.shapes.forEach(shape => this.shapeManager._removeShape(shape));
    }

    undo(): void {
        this.shapes.forEach(shape => this.shapeManager._addShape(shape));
    }
}
